import Service from "../../components/Service/Service";

const Included = () => {
  return (
    <>
      <div className="container background_gradient-top">
        <div className="column w64 g1">
          <h2>What's Included</h2>
          <p className="ctext">We offer 2 bookkeeping packages:</p>
          <div className="columns g1" style={{ marginBottom: "3rem" }}>
            <div className="card column g1">
              <div className="flex g1">
                <img
                  className="icon_small"
                  src={require("../../images/check.png")}
                  alt="check"
                />
                <strong className="purple">Essentials</strong>
              </div>
              <p className="ctext">
                Everything you need to keep organized and manage your finances
                effectively.
              </p>
            </div>
            <div className="card column g1 background_white shadow">
              <div className="flex g1">
                <img
                  className="icon_small"
                  src={require("../../images/premium.png")}
                  alt="check"
                />
                <strong className="purple">Premium</strong>
              </div>
              <p className="ctext">
                Includes all Essentials, plus specialized help and resources to
                scale your business.
              </p>
            </div>
          </div>
          <div className="column">
            <strong className="title">Accounting Maintenance</strong>
            <div className="columns shadow">
              <div className="column background_light">
                <Service>
                  <p>Weekly transaction entry + bookkeeping</p>
                </Service>
                <Service>
                  <p>Monthly account reconciliations</p>
                </Service>
                <Service>
                  <p>QuickBooks Online account maintenance</p>
                </Service>
                <Service>
                  <p>Sales and use tax reporting</p>
                </Service>
              </div>
              <div className="column background_white">
                <Service isPremium>
                  <p>Class tracking</p>
                </Service>
                <Service isPremium>
                  <p>Job and customer tracking</p>
                </Service>
                <Service isPremium>
                  <p>Detailed payroll journal entries</p>
                </Service>
                <Service isPremium>
                  <p>Limited A/R, A/P, and inventory services</p>
                </Service>
              </div>
            </div>
          </div>

          <div className="columns g1">
            <div className="column">
              <strong className="title">Monthly Financial Reports</strong>
              <div className="column background_light shadow">
                <Service>
                  <p>Balance sheet</p>
                </Service>
                <Service>
                  <p>Profit and loss</p>
                </Service>
                <Service>
                  <p>Bank reconciliation details</p>
                </Service>
                <Service>
                  <p>Amortization schedule</p>
                </Service>
                <Service>
                  <p>Depreciation schedule</p>
                </Service>
                <Service>
                  <p>Distribution schedule</p>
                </Service>
              </div>
            </div>
            <div className="column">
              <strong className="title">Year-End Financial Report</strong>
              <div className="column background_light shadow">
                <Service>
                  <p>Clear yearly financial picture</p>
                </Service>
                <Service>
                  <p>Comprehensive financial overview</p>
                </Service>
                <Service>
                  <p>Streamlined tax filing</p>
                </Service>
                <Service>
                  <p>Identify trends year over year</p>
                </Service>
                <Service>
                  <p>Prepare to get financing</p>
                </Service>
              </div>
            </div>
            <div className="column">
              <strong className="title">QuickBooks Online Training</strong>
              <div className="column background_light shadow">
                <Service>
                  <p>Master the basics</p>
                </Service>
                <Service>
                  <p>Direct receipt submission</p>
                </Service>
                <Service>
                  <p>On-demand reporting</p>
                </Service>
              </div>
            </div>
            <div className="column">
              <strong className="title">1099 Preparation</strong>
              <div className="column background_light shadow">
                <Service>
                  <p>Ensure accuracy and compliance</p>
                </Service>
                <Service>
                  <p>Stress-free contracting</p>
                </Service>
                <Service>
                  <p>One-step filing</p>
                </Service>
              </div>
            </div>
            <div className="column">
              <strong className="title">Monthly Forecasting</strong>
              <div className="column background_white shadow">
                <Service isPremium>
                  <p>Monthly cash flow forecast</p>
                </Service>
                <Service isPremium>
                  <p>Monthly balance sheet forecast</p>
                </Service>
                <Service isPremium>
                  <p>Monthly profit and loss forecast</p>
                </Service>
              </div>
            </div>
            <div className="column ">
              <strong className="title">Monthly Consulting Meeting</strong>
              <div className="column background_white shadow">
                <Service isPremium>
                  <p>Identify prosperous trends</p>
                </Service>
                <Service isPremium>
                  <p>Monitor financial goals</p>
                </Service>
                <Service isPremium>
                  <p>Personalized growth strategies</p>
                </Service>
                <Service isPremium>
                  <p>Your questions answered</p>
                </Service>
              </div>
            </div>
          </div>
          <a
            className="cta"
            href="https://calendar.app.google/cgho9MaUp1oADCZLA"
            target="_blank"
            rel="noopener noreferrer"
          >
            Get started
          </a>
        </div>
      </div>
    </>
  );
};

export default Included;
